import React from "react";
import { Card } from "react-bootstrap";
import FormatAddress from "go-core/components/Formatters/FormatAddress";
import { Loading } from "go-core/components/Loading";
import { NumberOrderOrganizationInfoApi } from "../../../../../../services/Api/Public/types";

interface Props {
	organizationInfo: NumberOrderOrganizationInfoApi | undefined;
}

const NumberSystemCompanyInfo = ({ organizationInfo }: Props) => {
	return (
		<Card className="number-system-company-info-card mb-4">
			<Card.Body>
				{!organizationInfo || !organizationInfo?.company ? (
					<Loading />
				) : (
					<>
						{organizationInfo.company.logo_link?.default_link && (
							<img className="mb-3" alt="logo" src={organizationInfo.company.logo_link.default_link} />
						)}
						<h5 className="mb-0">{organizationInfo.company.name}</h5>
						<p className="mb-0">
							<FormatAddress address={organizationInfo.company.address} />
						</p>
					</>
				)}
			</Card.Body>
		</Card>
	);
};

export default NumberSystemCompanyInfo;
